import { SvgIcon } from '@mui/material';
import * as React from 'react';

interface IMagicIconProps {
    fill?: string
    fontSize?: string
}

const MagicIcon: React.FunctionComponent<IMagicIconProps> = ({ fill, fontSize }) => {
    return (
        <SvgIcon viewBox="0 0 30 30" style={{ fontSize: fontSize }}>
            <g transform="matrix(1 0 0 1 -1384 -897 )">
                <path
                    d="M 22.897727272727273 6.1499999999999995  L 21.62727272727273 9.15  L 20.356818181818184 6.1499999999999995  L 17.284090909090914 4.77  L 20.356818181818184 3.4199999999999995  L 21.62727272727273 0.5699999999999995  L 22.897727272727273 3.4199999999999995  L 25.970454545454547 4.77  L 22.897727272727273 6.1499999999999995  Z M 22.897727272727273 24.12  L 21.62727272727273 27  L 20.356818181818184 24.12  L 17.284090909090914 22.77  L 20.356818181818184 21.42  L 21.62727272727273 18.39  L 22.897727272727273 21.42  L 25.970454545454547 22.77  L 22.897727272727273 24.12  Z M 11.404545454545453 16.47  L 8.656818181818183 22.379999999999995  L 5.938636363636365 16.469999999999995  L 0 13.77  L 5.938636363636364 11.069999999999999  L 8.656818181818181 5.189999999999999  L 11.404545454545453 11.069999999999999  L 17.313636363636363 13.77  L 11.404545454545453 16.47  Z M 7.268181818181821 15.059999999999999  L 8.656818181818183 17.939999999999998  L 10.075000000000001 15.059999999999999  L 12.970454545454547 13.77  L 10.075000000000003 12.48  L 8.656818181818185 9.6  L 7.268181818181822 12.48  L 4.343181818181821 13.77  L 7.268181818181821 15.059999999999999  Z "
                    fillRule="nonzero"
                    fill={fill ? fill : ""}
                    stroke="none"
                    transform="matrix(1 0 0 1 1384 897 )"
                />
            </g>
        </SvgIcon>
    );
};

    export default MagicIcon;